import { render, staticRenderFns } from "./semidonut_component.vue?vue&type=template&id=58c28ece"
import script from "./semidonut_component.vue?vue&type=script&lang=js"
export * from "./semidonut_component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports